export const GET_DAYS_WEEK_BY_COMPANIES = "GET_DAYS_WEEK_BY_COMPANIES"
export const GET_DAYS_WEEK_BY_COMPANIES_SUCCESS = "GET_DAYS_WEEK_BY_COMPANIES_SUCCESS"

export const GET_DAYS_WEEK_BY_COMPANIES_API_ERROR = "GET_DAYS_WEEK_BY_COMPANIES_API_ERROR"
